import { type CheckoutEventsData } from '@paddle/paddle-js'

/** Maps a Paddle `checkout.completed` payload (`event.data`) into Meta `custom_data`; `value` is the net
 * subtotal, the backend's conversion-value convention. */
export const buildMetaPurchaseCustomData = (data: CheckoutEventsData | undefined): Record<string, unknown> => {
  if (!data) return {}

  const { totals, items, currency_code: currency, transaction_id: orderId } = data

  const customData: Record<string, unknown> = {
    currency,
    value: totals.subtotal,
    subtotal: totals.subtotal,
    tax: totals.tax,
    discount: totals.discount,
    total: totals.total,
    num_items: items.reduce((sum, item) => sum + item.quantity, 0),
    order_id: orderId
  }

  const contentName = items
    .map((item) => item.product.name)
    .filter(Boolean)
    .join(', ')
  if (contentName) customData.content_name = contentName

  const contentIds = items.map((item) => item.price_id).filter(Boolean)
  if (contentIds.length) customData.content_ids = contentIds

  customData.contents = items.map((item) => ({
    id: item.price_id,
    quantity: item.quantity,
    item_price: item.totals.subtotal
  }))

  return customData
}
